<template>
  <div class="total-products-results-container">
    <v-data-table fixed-header disable-pagination hide-default-footer :headers="headers" :items="items" no-data-text="Sem dados">
      <template v-slot:[`item.activated_clients`]="{ item }">
        {{ item.activated_clients }}
      </template>
      <template v-slot:[`item.clients`]="{ item }">
        {{ item.clients | abreviation({ isInteger: true }) }}
      </template>
      <template v-slot:[`item.tickets`]="{ item }">
        {{ item.tickets | abreviation({ isInteger: true }) }}
      </template>
      <template v-slot:[`item.quantity`]="{ item }">
        {{ locale(item.quantity, 2) | localeString(0, 2) }}
      </template>
      <template v-slot:[`item.revenue`]="{ item }">
        <span>{{ locale(item.revenue, 2) | localeString(2) | currency }}</span>
      </template>
      <template v-slot:[`item.discounts`]="{ item }">
        <div v-if="!isPointsCurrentOfferType">
          {{ locale(item.discounts, 2) | localeString(2) | currency }}
        </div>

        <div v-else>
          {{ item.discounts | localeString(0) | abreviation({ isInteger: true }) }}
        </div>
      </template>
      <template v-slot:[`item.offers_schedule_discounts`]="{ item }">
        {{ locale(item.offers_schedule_discounts, 2) | localeString(2) | currency }}
      </template>
      <template v-slot:[`item.impact`]="{ item }">
        {{ locale(item.impact, 2) | localeString(2) | percent }}
      </template>
    </v-data-table>
    <span class="products-label">No próximo slide você pode ver o resultado por produto (Limite máximo de 10 produtos)</span>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

export default {
  name: 'TotalProductsResultsTable',
  props: {
    metrics: {
      type: Object,
      default: () => {},
    },
    currentOfferTypeKeyName: {
      type: String,
      default: '',
    },
    campaignModel: {
      type: String,
      default: 'sales',
    },
  },
  data: () => ({
    locale: localeString,
    offerSalesKeyNames: {
      offer_sales: 'offer_sales',
      percentage_offer_sales: 'percentage_offer_sales',
      takepay_offer_sales: 'takepay_offer_sales',
      combo_offer_sales: 'combo_offer_sales',
      target_products: 'target_products',
      cashback_percentage_offer_sales: 'cashback_percentage_offer_sales',
      cashback_absolute_offer_sales: 'cashback_absolute_offer_sales',
      points_offer_sales: 'points_offer_sales',
    },
  }),
  computed: {
    isCashbackOrPointsCurrentOfferType() {
      return this.isCashbackCurrentOfferType || this.isPointsCurrentOfferType
    },
    isCashbackCurrentOfferType() {
      return [this.offerSalesKeyNames.cashback_percentage_offer_sales, this.offerSalesKeyNames.cashback_absolute_offer_sales].includes(
        this.currentOfferTypeKeyName
      )
    },
    isPointsCurrentOfferType() {
      return this.offerSalesKeyNames.points_offer_sales === this.currentOfferTypeKeyName
    },
    offerColumnLabel() {
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) return 'Cashback distribuido'
        else return 'Pontos distribuídos'
      }
      return 'Desconto concedido'
    },
    items() {
      let discountsLabel = ''
      if (this.isCashbackOrPointsCurrentOfferType) {
        if (this.isCashbackCurrentOfferType) discountsLabel = 'cashback'
        else discountsLabel = 'points'
      } else discountsLabel = 'discounts'
      return [
        {
          quantity: this.metrics?.products_metrics?.totals.sales.quantity,
          activated_clients: this.metrics?.products_metrics?.totals.sales.activated_clients,
          discounts: this.metrics?.products_metrics?.totals.sales[discountsLabel],
          offers_schedule_discounts: this.metrics?.products_metrics?.totals.sales.offers_schedule_discounts,
          revenue: this.metrics?.products_metrics?.totals.sales.revenue,
          tickets: this.metrics?.products_metrics?.totals.sales.tickets,
          clients: this.metrics?.products_metrics?.totals.sales.clients,
          impact: this.getSafe(() => this.metrics?.products_metrics?.totals.sales.quantity / this.metrics?.products_metrics?.totals.total.quantity) * 100 || 0,
        },
      ]
    },
    headers() {
      const headers = [
        {
          text: 'Clientes',
          value: 'clients',
          sortable: false,
        },
        {
          text: 'Cupons',
          value: 'tickets',
          sortable: false,
        },
        {
          text: 'Unidades com desconto',
          value: 'quantity',
          sortable: false,
        },
        {
          text: 'Faturamento',
          value: 'revenue',
          sortable: false,
        },
        {
          text: this.offerColumnLabel,
          value: 'discounts',
          sortable: false,
        },
        {
          text: 'Impacto',
          value: 'impact',
          sortable: false,
        },
      ]

      if (!this.isCashbackOrPointsCurrentOfferType) {
        headers.splice(7, 0, {
          text: 'Desconto da gestão',
          value: 'offers_schedule_discounts',
          isActive: true,
          isRequired: false,
          isDefault: true,
        })
      }

      if (this.campaignModel === 'activatable') {
        headers.splice(2, 0, {
          text: 'Clientes que ativaram',
          value: 'activated_clients',
          isActive: true,
          isRequired: false,
          isDefault: true,
        })
      }
      return headers
    },
  },
  methods: {
    localeString,
  },
}
</script>

<style lang="scss" scoped>
.total-products-results-container {
  display: flex;
  flex-direction: column;
  gap: 100px;
  justify-content: center;
  .products-label {
    text-align: center;
    color: $marca-0-l20;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
}
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  border-left: 1px solid #eee;
}
::v-deep thead th {
  border-bottom: 1px solid #eee !important;
}

::v-deep .v-data-table-header tr,
::v-deep .v-data-table-header th {
  background: #fff !important;
  border-top: 1px solid #fff !important;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 12px;
    line-height: 1;
    border-left: 1px solid #eee;
  }
}
::v-deep tbody {
  td:first-child {
    border-left: none;
  }
}
::v-deep th:first-child {
  border-left: none;
}
</style>
